var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStore1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4509 7.15255L25.5134 1.15255C25.446 0.94557 25.3148 0.767053 25.1399 0.644266C24.965 0.521478 24.7559 0.461169 24.5446 0.472551H3.23215C3.0209 0.461169 2.81184 0.521478 2.63691 0.644266C2.46199 0.767053 2.3308 0.94557 2.2634 1.15255L0.325897 7.15255C0.31194 7.25873 0.31194 7.36637 0.325897 7.47255V13.4726C0.325897 13.7378 0.427962 13.9921 0.609638 14.1797C0.791313 14.3672 1.03772 14.4726 1.29465 14.4726H2.2634V24.4726H4.2009V14.4726H10.0134V24.4726H25.5134V14.4726H26.4821C26.7391 14.4726 26.9855 14.3672 27.1672 14.1797C27.3488 13.9921 27.4509 13.7378 27.4509 13.4726V7.47255C27.4649 7.36637 27.4649 7.25873 27.4509 7.15255ZM23.5759 22.4726H11.9509V14.4726H23.5759V22.4726ZM25.5134 12.4726H21.6384V8.47255H19.7009V12.4726H14.8571V8.47255H12.9196V12.4726H8.0759V8.47255H6.1384V12.4726H2.2634V7.63255L3.92965 2.47255H23.8471L25.5134 7.63255V12.4726Z",
    fill: "#1BA397"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore1);
export default __webpack_public_path__ + "static/media/store1.e8447d3dfa9fb9ecbcfda8a93f313b05.svg";
export { ForwardRef as ReactComponent };